module.exports = __webpack_public_path__ + "static/media/signInBG.0f915605.png";